import React from 'react';
import PropTypes from 'prop-types';
import { mappedAtColumn } from './sharedColumns';
import { candidateCellColumn } from './CandidateCell';
import PipelineDataTable, { candidateShape } from './PipelineDataTable';
import TabEmptyState from './TabEmptyState';
import { registerTab } from './tabRegistry';

// Default flow — "Non Responsive" tab. New tab, not present in the old
// RequirementPipeline.jsx — per instruction, this is a plain read-only table with
// no row/bulk actions of any kind (deliberately no RowActionsCell here
// either, unlike every other tab — that instruction was explicit). Registry
// key matches the flow-statuses API's exact status string
// ("Non Responsive") — see FailedTab.jsx's comment.
const columns = [candidateCellColumn, mappedAtColumn];

const NonResponsiveTab = ({
  candidates,
  isLoading,
  page,
  pageSize,
  totalPages,
  totalItems,
  onPageChange,
  onPageSizeChange,
}) => (
  <PipelineDataTable
    columns={columns}
    candidates={candidates}
    isLoading={isLoading}
    page={page}
    pageSize={pageSize}
    totalPages={totalPages}
    totalItems={totalItems}
    onPageChange={onPageChange}
    onPageSizeChange={onPageSizeChange}
    emptyState={<TabEmptyState description="No non-responsive candidates." />}
  />
);

NonResponsiveTab.propTypes = {
  candidates: PropTypes.arrayOf(candidateShape),
  isLoading: PropTypes.bool,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  totalPages: PropTypes.number,
  totalItems: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
};

NonResponsiveTab.defaultProps = {
  candidates: [],
  isLoading: false,
  page: 1,
  pageSize: 10,
  totalPages: 1,
  totalItems: 0,
  onPageChange: () => {},
  onPageSizeChange: () => {},
};

registerTab({
  stateMachineKey: 'default',
  state: 'Non Responsive',
  component: NonResponsiveTab,
});

export default NonResponsiveTab;
